import { MeeLogo } from "src/shell/MeeLogo";
import { getBrand } from "./brand";

/**
 * The deployment's logo. On a Mee stack (`wordmark`) this is the inline Mee
 * wordmark, which inherits `currentColor` so a branded header can tint it. On
 * a client stack (`static`) it is the client's own `/branding/logo.svg` in an
 * `<img>`, which CSS `color` cannot reach — client artwork is drawn exactly as
 * supplied, never tinted, so it must carry its own fills.
 */
export function BrandLogo({ className }: { className?: string }) {
	const { logoStyle, logoUrl, productName } = getBrand();
	if (logoStyle === "static") {
		return <img src={logoUrl} alt={productName} className={className} />;
	}
	return <MeeLogo className={className} />;
}
